import type { IContextMutationResult } from '@modules/core/services/query/types';
import type {
  MirrorsListCreatePayload,
} from '@modules/mirrors-list/submodules/create/submodules/manually/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  MIRRORS_LIST_PERMISSIONS,
  MIRRORS_LIST_QUERY_KEY,
} from '@modules/mirrors-list/constants';
import {
  MIRROR_CREATE_MANUALLY_MUTATION_API_URL,
  MIRROR_CREATE_MANUALLY_MUTATION_KEY,
} from '@modules/mirrors-list/submodules/create/submodules/manually/constants';
import { useToastStore } from '@modules/toast/store';

export default function useMirrorAddManuallyMutation(): IContextMutationResult<void, Error, MirrorsListCreatePayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, MirrorsListCreatePayload>({
    mutationKey: [MIRROR_CREATE_MANUALLY_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      MIRROR_CREATE_MANUALLY_MUTATION_API_URL,
      { mirror: payload },
      {
        permission: MIRRORS_LIST_PERMISSIONS.CREATE,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [MIRRORS_LIST_QUERY_KEY] });
      displayPresetToast('success');
    },
  });
}
